import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	container: {
		display        : "flex",
		// alignItems : "center",
		// justifyContent : "space-between"
		margin         : "1rem 0",
		justifyContent : "start",
		gap            : "1.5rem"
	}

} );
